// src/pages/nascar/XfData.jsx
import NascarData from "./NascarData";
export default function XfData() { return <NascarData series="xfinity" />; }